import createReactComponent from '../createReactComponent';
export default createReactComponent('tallymark-3', 'IconTallymark3', [
  ['path', { d: 'M8 5l0 14', key: 'svg-0' }],
  ['path', { d: 'M12 5l0 14', key: 'svg-1' }],
  ['path', { d: 'M16 5l0 14', key: 'svg-2' }],
]);
